/**
 * Represents the possible statuses for the Atlas merge preparation process.
 *
 * @property Completed - Indicates that the merge preparation has completed successfully.
 * @property Failed - Indicates that the merge preparation has failed.
 * @property ConnectionError - Indicates that a connection error occurred during merge preparation.
 * @property InProgress - Indicates that the merge preparation is currently in progress.
 * @property Errored - Indicates that an unspecified error occurred during merge preparation.
 */
export const enum AtlasMergePrepStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  ConnectionError = 'ConnectionError',
  InProgress = 'InProgress',
  Errored = 'Errored'
}

export default AtlasMergePrepStatus;
